import Immutable from 'immutable'

export const ListClientRecord = Immutable.Record({
  abn: null,
  id: null,
  name: null,
}, 'ListClient')

export default function createListClient(data) {
  return new ListClientRecord(data)
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/records/ListClient.js